<app-alert></app-alert>

<app-placeholder-company *ngIf="!company || !currentUser || !members"></app-placeholder-company>

<div *ngIf="company && currentUser && members" class="companyPage">
    <h1 class="mat-h1 companyPageHeader">
        <strong>{{ company.name }}</strong> company settings
    </h1>

    <form *ngIf="currentUser && currentUser.role === 'ADMIN'"
        class="company-name-settings"
        (ngSubmit)="changeCompanyName()">
        <mat-form-field appearance="outline" class="company-name-settings__name">
            <mat-label>Name</mat-label>
            <input matInput name="company-name" #nameField="ngModel"
                data-testid="company-name-input"
                angulartics2On="change"
                angularticsAction="Company: company name is edited"
                [(ngModel)]="company.name">
        </mat-form-field>
        <button type="submit"
            mat-button color="primary" class="company-name-settings__save-button"
            [disabled]="!nameField.dirty || submittingChangedName">
            Save
        </button>
    </form>

    <div *ngIf="isSaas" class="company-plan">
        <div>
            <strong>Current plan: </strong>
            <span class="company-plan-name" data-testid="company-plan-string">{{currentPlan}}</span>
        </div>
        <div class="company-plan__paymnent-buttons">
            <a *ngIf="currentUser && currentUser.role === 'ADMIN'"
                mat-button color="accent" class="upgrade-button"
                [href]="company.portal_link" target="_blank"
                data-testid="company-payment-portal-link"
                angulartics2On="click"
                angularticsAction="Company: Manage payment settings is clicked">
                <span>Stripe settings</span>
            </a>
            <a *ngIf="currentUser && currentUser.role === 'ADMIN'"
                mat-stroked-button color="accent" class="upgrade-button"
                routerLink="/upgrade"
                data-testid="company-payment-settings-link"
                angulartics2On="click"
                angularticsAction="Company: Manage payment settings is clicked">
                Update
            </a>
        </div>

    </div>

    <div class="tableHeader">
        <h2 class="heading-2">Members <span *ngIf="currentPlan === 'free' && isSaas" data-testid="company-members-max-string">(max 3)</span></h2>
        <div data-testid="company-invitation-button-wrapper"
            [matTooltip]="currentPlan === 'free' && usersCount >= 3 && isSaas ? 'To add more members please upgrade your plan.' : null">
            <button *ngIf="currentUser && currentUser.role === 'ADMIN'"
                mat-flat-button type="button"
                data-testid="company-invitation-button"
                angulartics2On="click"
                angularticsAction="Company: invite member is clicked"
                class="tableHeader__button" color="primary"
                (click)="handleAddMemberDialogOpen()"
                [disabled]="currentPlan === 'free' && usersCount >= 3 && isSaas">
                Invite member
                <mat-icon *ngIf="currentPlan === 'free' && usersCount >= 3 && isSaas">
                    info_outline
                </mat-icon>
            </button>
        </div>
    </div>

    <app-placeholder-table-data *ngIf="submittingUsersChange"></app-placeholder-table-data>
    <table *ngIf="currentUser && members.length && !submittingUsersChange" mat-table [dataSource]="members" class="mat-elevation-z4 company-members-table">
        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element; let i = index"
            class="company-member-cell"
            data-label="Email"
            attr.data-testid="company-member-email-{{i}}-cell">
            <span>{{element.email}}</span>
        </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element; let i = index"
                data-label="Name"
                class="company-member-cell">
                <span *ngIf="!element.invitedUserEmail" attr.data-testid="company-member-name-{{i}}-cell">{{element.name || '—'}}</span>
            </td>
        </ng-container>

        <!-- Role Column -->
        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Role</th>
            <td mat-cell *matCellDef="let element; let i = index"
                data-label="Role"
                class="company-member-cell">
                <mat-select *ngIf="currentUser && currentUser.role === 'ADMIN' && (adminsCount > 1 || element.role === 'USER') && !element.invitedUserEmail; else noSelect"
                    attr.data-testid="company-member-role-{{i}}-select"
                    class="role-select"
                    angulartics2On="click"
                    angularticsAction="Company: role is clicked"
                    [(ngModel)]="element.role"
                    (ngModelChange)="updateRole(element.id, element.role)">
                    <mat-option value="ADMIN" attr.data-testid="company-member-superadmin-role-{{i}}-select-option">
                        Superadmin
                    </mat-option>
                    <mat-option value="USER" attr.data-testid="company-member-user-role-{{i}}-select-option">
                        Member
                    </mat-option>
                </mat-select>
                <ng-template #noSelect attr.data-testid="company-member-user-role-{{i}}-cell">
                    {{element.role === "ADMIN" ? 'Superadmin' : 'Member'}}
                </ng-template>
            </td>
        </ng-container>

        <!-- 2fa Column -->
        <ng-container matColumnDef="twoFA">
            <th mat-header-cell *matHeaderCellDef>2fa</th>
            <td mat-cell *matCellDef="let element; let i = index"
                data-label="2fa"
                class="company-member-cell">
                <div *ngIf="!element.invitedUserEmail">
                    <mat-icon *ngIf="element.is_2fa_enabled; else noTwoFA" color="accente"
                        attr.data-testid="company-member-2fa-{{i}}-enabled-icon">
                        done
                    </mat-icon>
                    <ng-template #noTwoFA>
                        <mat-icon attr.data-testid="company-member-2fa-{{i}}-disabled-icon">remove</mat-icon>
                    </ng-template>
                </div>
            </td>
        </ng-container>

        <!-- Active Column -->
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Active status</th>
            <td mat-cell *matCellDef="let element; let i = index"
                data-label="Active status"
                class="active-status-cell company-member-cell">
                <mat-slide-toggle *ngIf="!element.invitedUserEmail"
                    class="active-status-toggle"
                    [disabled]="unsuspendedAdminsCount === 1 && element.role === 'ADMIN' && currentUser.email === element.email"
                    attr.data-testid="company-member-active-{{i}}-toggle"
                    angulartics2On="click"
                    angularticsAction="Company: suspend user is toggled"
                    [angularticsProperties]="{'enable': element.suspended}"
                    [(ngModel)]="!element.suspended"
                    (change)="switchSuspendance($event.checked, element.email)">
                </mat-slide-toggle>
            </td>
        </ng-container>

        <!-- Delete Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element; let i = index"
                class="company-member-cell-action">
                <button mat-button *ngIf="element.invitedUserEmail; else deleteUserButton"
                    type="button" color="warn"
                    attr.data-testid="company-member-revoke-{{i}}-button"
                    angulartics2On="click"
                    angularticsAction="Company: Revoke invitation is clicked"
                    (click)="handleRevokeInvitationDialogOpen(element.email)">
                    Revoke
                </button>
                <ng-template #deleteUserButton>
                    <button mat-button *ngIf="(adminsCount > 1 && currentUser.role === 'ADMIN') || element.role === 'USER'"
                        type="button" color="warn"
                        attr.data-testid="company-member-delete-{{i}}-button"
                        angulartics2On="click"
                        angularticsAction="Company: Delete member is clicked"
                        (click)="handleDeleteMemberDialogOpen(element)">
                        Delete
                    </button>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="membersTableDisplayedColumns" class="company-members-table-heading"></tr>
        <tr mat-row *matRowDef="let row; columns: membersTableDisplayedColumns;" class="company-member-row"></tr>
    </table>
</div>

